import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

/**
 * Vuetify make use of a theme 'light' and 'dark'
 * but our palette only use 'brand' and 'neutral' colors
 *
 * to say: our palette do not have a 'light' and 'dark' theme
 *
 * because of that, to use a 'dark theme'
 * it's necessary to manually set it in the component
 */

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        // DO NOT CHANGE 'brand' or 'neutral'
        // for color reference, go to '@/assets/scss/src/_variables.scss'

        'feedback-danger-background': '#FFF5F5',
        'feedback-warning-background': '#FFF8F0',
        'feedback-success-background': '#F5FFF5',
        'trial-trial': '#BF3FEE',
        'trial-trial-dark': '#7A0FA1',
        'trial-trial-darkest': '#5F1E77',
        'trial-background': '#FCF5FF',

        'neutral-30-base': '#3F404C',
        'neutral-40-light': '#636578',
        'neutral-80-lighter': '#D0D1D9',
        'neutral-95-lightest': '#EDEEF1',
        'neutral-20-dark': '#282931',
        'neutral-10-darker': '#1B1B20',
        'neutral-0-darkest': '#121215',
        'neutral-background': '#F7F7F8',
        'feedback-danger': '#F44336',
        'feedback-danger-light': '#FFCDD2',
        'feedback-danger-dark': '#B71C1C',
        'feedback-warning': '#FFC107',
        'feedback-warning-light': '#FFECB3',
        'feedback-warning-dark': '#9E5000',
        'feedback-success': '#4CAF50',
        'feedback-success-light': '#C8E6C9',
        'feedback-success-dark': '#174F1B',
        'neutral-100-white': '#FFFFFF',
        'neutral-50': '#73778C',
        'neutral-60': '#8F92A3',
        'neutral-70': '#ABADBA',
        'neutral-99': '#F9F9FB',
        'neutral-90': '#E3E4E8',

        'brand-60-base': '#3F55EE',

        'brand-40-dark': '#0F22A1',
        'brand-30-darker': '#1E2A77',
        'brand-20-darkest': '#0B134A',

        'brand-80-light': '#A0ACFF',
        'brand-95-lighter': '#EBEEFF',
        'brand-99-lightest': '#F8F9FF',

        'brand-0': '#02061C',
        'brand-50': '#1530EA',
        'brand-10': '#040A2F',
        'brand-70': '#7283F3',
        'brand-90': '#D0D6FB',

        brand: {
          base: '#3f55ee',
          lighten1: '#a0acff',
          lighten2: '#ebedff',
          lighten3: '#f8f8ff',
          darken1: '#0f21a1',
          darken2: '#1e2977',
          darken3: '#0B134A',
          background: '#f8f8ff',
        },
        neutral: {
          base: '#373B54',
          lighten1: '#585D83',
          lighten2: '#C2C6E7',
          lighten3: '#E6E8F8',
          lighten4: '#FFFFFF',
          lighten5: '#3F404C',
          darken1: '#232536',
          darken2: '#171924',
          darken3: '#0F1118',
        },
        // DO NOT CHANGE 'brand' or 'neutral'

        primary: '#3F55EE',
        blueMarine: {
          base: '#585D83',
          darken1: '#1E2977',
          darken2: '#373B54',
          lighten1: '#C2C6E7',
        },
        progressBar: {
          base: '#c5cbfd',
          lighten1: '#eeeeee',
          darken1: '#A7B2FF',
        },
        light: '#5b9bf3',
        secondary: '#F9F9F9',
        turquisePanda: '#3e50f7',
        background: '#FFFFFF',
        backgroundAlert: '#f1f3f4',
        lighter: '#e7e9fa',
        darker: '#131e3f',
        icon: '#C1CBE6',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        text: '#FFFFFF',
        secondaryText: '#6F6F6F',
        black: '#000000',
        issue: '#FDEDF5',
        notSelectedOption: '#3F55EE',
        selectedOption: '#2B3BAB',
        newTitle: '#1E2977',
        newBackground: '#f8f8ff',
        lightenText: '#A0ACFF',
        backgroundLighten: '#ffffff',
        menuText: '#3F55EE',
        contrast: '#E6E8F8',
        tabsSelected: '#0F21A1',
        tabsUnselected: '#585D83',
        feedback: '#FFECB3',
        button: '#3F55EE',
        btnBg: '#3F55EE',
        btnBgCancel: '#EDEEF1',
        danger: {
          base: '#FFCDD2',
          darken1: '#B71C1C',
        },
        textType: '#585D83',
        textType2: '#373B54',
        textType3: '#282931',
        textType4: '#8f92a3',
        textType5: '#3f404c',
        textType6: '#636578',
        btnColor: '#EDEEF1',
      },
      dark: {
        // DO NOT CHANGE 'brand' or 'neutral'
        // for color reference, go to '@/assets/scss/src/_variables.scss'
        'brand-60-base': '#697AF2',
        'brand-80-light': '#0A21C2',
        'brand-95-lighter': '#061679',
        'brand-99-lightest': '#051161',
        'brand-40-dark': '#93A1FB',
        'brand-30-darker': '#BAC1F3',
        'brand-20-darkest': '#DEE2FC',
        'neutral-30-base': '#C2C5D6',
        'neutral-40-light': '#B9BBC6',
        'neutral-80-lighter': '#52577A',
        'neutral-95-lightest': '#363949',
        'neutral-20-dark': '#E3E4E8',
        'neutral-10-darker': '#F0F1F5',
        'neutral-0-darkest': '#FCFCFD',
        'feedback-danger': '#F44336',
        'feedback-danger-light': '#921616',
        'feedback-danger-dark': '#FFCDD2',
        'feedback-warning': '#FFC71F',
        'feedback-warning-light': '#BD5F00',
        'feedback-warning-dark': '#FFF4D1',
        'feedback-success': '#4CAF50',
        'feedback-success-light': '#1B5E20',
        'feedback-success-dark': '#DCEFDD',
        'neutral-100-white': '#000000',
        'neutral-50': '#A3A7C2',
        'neutral-60': '#757BA3',
        'neutral-70': '#666D99',
        'brand-50': '#798AFB',
        'neutral-99': '#2C2E3A',
        'neutral-90': '#3C415D',
        'brand-10': '#F5F6FF',
        'brand-70': '#203CF8',
        'brand-90': '#0C1C8D',
        'neutral-background': '#2F3037',
        'feedback-danger-background': '#330000',
        'feedback-warning-background': '#3D2300',
        'feedback-success-background': '#003303',
        'brand-0': '#FAFBFF',
        'trial-trial': '#D73FEE',
        'trial-trial-dark': '#EBA2F6',
        'trial-trial-darkest': '#F6E7F9',
        'trial-background': '#250033',

        brand: {
          base: '#3f55ee',
          lighten1: '#a0acff',
          lighten2: '#ebedff',
          lighten3: '#f8f8ff',
          darken1: '#0f21a1',
          darken2: '#1e2977',
          darken3: '#0B134A',
          background: '#0F1118',
        },
        neutral: {
          base: '#373B54',
          lighten1: '#585D83',
          lighten2: '#C2C6E7',
          lighten3: '#E6E8F8',
          lighten4: '#FFFFFF',
          lighten5: '#3F404C',
          darken1: '#232536',
          darken2: '#171924',
          darken3: '#0F1118',
        },
        // DO NOT CHANGE 'brand' or 'neutral'

        primary: '#A0ACFF',
        blueMarine: {
          base: '#C2C6E7',
          darken1: '#8fb1e3',
          darken2: '#E6E8F8',
          lighten1: '#C2C6E7',
        },
        progressBar: {
          base: '#373B54',
          lighten1: '#eeeeee',
          darken1: '#ebedff',
        },
        main: '#121212',
        background: '#171924',
        backgroundAlert: '#272b2c',
        text: '#cdcbc9',
        turquisePanda: '#478ef7',
        issue: '#39061f',
        notSelectedOption: '#3F55EE',
        newTitle: '#EBEDFF',
        newBackground: '#0F1118',
        backgroundLighten: '#373b54',
        menuText: '#A0ACFF',
        contrast: '#373B54',
        tabsSelected: '#EBEDFF',
        tabsUnselected: '#A0ACFF',
        feedback: '#7d5e00',
        button: '#3F55EE',
        btnBg: '#3F55EE',
        btnBgCancel: '#363949',
        danger: {
          base: '#FFCDD2',
          darken1: '#B71C1C',
        },
        textType: '#FFFFFF',
        textType2: '#FFFFFF',
        textType3: '#EDEEF1',
        textType4: '#EDEEF1',
        textType5: '#EDEEF1',
        textType6: '#EDEEF1',
        btnColor: '#3F55EE',
      },
    },
  },
})
